import styled from "styled-components";
import {GameJackpotValueDefaultBox} from "./game-jackpot-value.default.box";

export const GameJackpotValueMrGreenBox = styled(GameJackpotValueDefaultBox)`
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: bold;
    font-size: 16px;
    background: ${props => props.theme.colors.brandPrimaryDark};
    box-shadow: 0px 0px 0px rgba(1, 85, 54, 0.6), inset 0px 0px 20px rgba(255, 255, 255, 0.1), inset 0px 0px 10px ${props => props.theme.colors.brandSecondary};
    color: ${props => props.theme.colors.moneyColor};
    height: 30px;
    border-radius: 3px;
    margin-left: auto;
    margin-right: auto;
    margin-bottom: 5px;
    margin-top: 5px;
    
    @media ${({theme}) => theme.mediaQuery.sAndBelow} {
        font-size: 12px;
        width: 108px;
        height: 20px;
    }
    
    @media ${({theme}) => theme.mediaQuery.xs} {
    font-size: 10px;
    width: 88px;
    height: 20px;
    }
`;